export function MovisAvatar({
  size = 32,
  className = "",
  glowing = true,
  floating = false,
}: {
  size?: number;
  className?: string;
  glowing?: boolean;
  floating?: boolean;
}) {
  return (
    <div
      className={`movis-avatar-container ${floating ? "is-floating" : ""} ${glowing ? "is-glowing" : ""} ${className}`}
      style={{ width: size, height: size }}
    >
      <img
        src="/app-icons/app-icon-gradient-192.png"
        alt="Movis Agent"
        className="movis-avatar-img"
      />
      {glowing && <span className="movis-avatar-aura" />}
    </div>
  );
}
